import React from 'react';
import { Container, Box, Typography } from '@mui/material';

const DashboardLayout = ({ title, children }) => {
    return (
        <Container 
            maxWidth="lg" 
            sx={{ 
                mt: { xs: 2, md: 4 }, 
                mb: 4, 
                /* Symmetrical padding ensures the gap is equal on both left and right */
                px: { xs: 2, sm: 3, md: 4 }, 
                /* Force auto-centering */
                mx: 'auto',
                display: 'flex',
                flexDirection: 'column',
                width: '100%'
            }}
        >
            <Box sx={{ width: '100%', mb: { xs: 2, md: 4 } }}>
                <Typography 
                    variant="h4" 
                    component="h1" 
                    sx={{ 
                        fontWeight: 700,
                        /* Keeps the bulletproof text wrapping */
                        wordBreak: 'break-word', 
                        overflowWrap: 'break-word',
                        fontSize: { xs: '1.75rem', md: '2.125rem' }
                    }}
                >
                    {title}
                </Typography>
            </Box>
            
            {/* Wrapper to ensure the children stretch symmetrically */ }
            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                <Box sx={{ width: '100%', maxWidth: '100%' }}>
                    {children}
                </Box>
            </Box>
        </Container>
    );
};

export default DashboardLayout;